<div
  class="asset-explorer"
  [class.asset-explorer--with-details]="selectedAsset()"
>
  <lib-explorer-toolbar
    [isLoading]="isLoading()"
    [viewMode]="viewMode()"
    (refresh)="onRefresh()"
    (viewModeChange)="onViewModeChange($event)"
  ></lib-explorer-toolbar>

  <div class="asset-explorer__body">
    <div class="asset-explorer__content">
      @if (isLoading()) {
        <div class="asset-explorer__loading-overlay">
          <lib-loading-spinner [size]="40" label="Loading..." />
        </div>
      }

      @if (error() && !isLoading()) {
        <div class="asset-explorer__error">
          <p>{{ error() }}</p>
          <button tds-button (click)="onRefresh()">Retry</button>
        </div>
      }

      @if (!error()) {
        <div
          class="asset-explorer__tree-container"
          [class.asset-explorer__tree-container--loading]="isLoading()"
        >
          @if (nodeError()) {
            <div class="asset-explorer__node-error">
              <span>{{ nodeError() }}</span>
              <button
                class="asset-explorer__node-error-dismiss"
                (click)="dismissNodeError()"
              >
                ✕
              </button>
            </div>
          }

          @if (dataSource().length > 0) {
            <lib-tree-view
              #treeView
              [dataSource]="dataSource()"
              (nodeSelected)="onTreeNodeSelected($event)"
              (nodeExpanded)="onNodeExpanded($event)"
            />
          } @else if (!isLoading()) {
            <div class="asset-explorer__empty">
              <p>No assets found</p>
            </div>
          }
        </div>
      }
    </div>

    @if (selectedAsset()) {
      <div class="asset-explorer__details">
        <lib-asset-details
          [asset]="selectedAsset()!"
          [timeseriesProperties]="selectedAssetTimeseriesProperties()"
          (close)="onCloseDetails()"
          (navigateToAsset)="onNavigateToAsset($event)"
          (propertyUpdated)="onPropertyUpdated($event)"
        />
      </div>
    }

    @if (selectedTypeNode()) {
      <div class="asset-explorer__details">
        <lib-type-details
          [typeNode]="selectedTypeNode()!"
          [assets]="selectedTypeAssets()"
          (close)="onCloseDetails()"
          (navigateToAsset)="onNavigateToAsset($event)"
        />
      </div>
    }
  </div>
</div>
